module.exports = __webpack_public_path__ + "static/img/modular1.c2cc53d4.png";